import { types, Instance, SnapshotOut } from "mobx-state-tree";
import api from "services/api/api";

const Coordinates = types.model("coordinates").props({
  coordinates: types.array(types.number),
});

const AlarmsModel = types.model("Alarms").props({
  address: types.maybeNull(types.string),
  serial: types.maybeNull(types.string),
  temperature: types.maybeNull(types.number),
  tempWeather: types.maybeNull(types.number),
  id: types.maybeNull(types.string),
  connected: types.maybeNull(types.boolean),
  energy: types.maybeNull(types.boolean),
  connectedDate: types.maybeNull(types.string),
  digitalInput: types.maybeNull(types.boolean),
  location: types.maybeNull(Coordinates),
  group: types.maybeNull(types.string),
});

const Location = types.model("Location").props({
  lat: types.number,
  lng: types.number,
});

export const EnergyMonitorModelAlarm = types
  .model("EnergyMonitor")
  .props({
    alarms: types.optional(types.array(AlarmsModel), []),
    locationSelected: types.maybeNull(Location),
    idSelected: types.maybeNull(types.string),
    isLoading: types.boolean,
    idLoading: types.maybeNull(types.string),
    center: Location,
  })
  .views((self) => ({
    filterValues(value: string | null) {
      if (value === null) return self.alarms;
      return self.alarms.filter(
        (alarm) =>
          alarm.id?.toLowerCase().includes(value.toLowerCase()) ||
          alarm.address?.toLowerCase().includes(value.toLowerCase()) ||
          alarm.temperature?.toString().includes(value.toLowerCase())
      );
    },
  }))
  .actions((self) => {
    function setAlarms(alarms: any) {
      self.alarms = alarms;
    }
    function setlocationSelected(cordinates: any) {
      self.locationSelected = cordinates;
    }
    function setId(id: any) {
      self.idSelected = self.idSelected === id ? null : id;
    }
    function setIsLoading(isLoading: boolean, id: string | null) {
      self.idLoading = id;
      self.isLoading = isLoading;
    }
    function setLoading(loading: any) {
      self.isLoading = loading;
    }
    function setCenter(coordinates: any) {
      self.center = coordinates;
    }
    return {
      setAlarms,
      setlocationSelected,
      setCenter,
      setIsLoading,
      setLoading,
      setId,
    };
  })
  .actions((self) => ({
    getDevices: async () => {
      try {
        self.setLoading(true);
        const alarmsApi = api.energymonitor;
        const response = await alarmsApi.getDevice();
        self.setAlarms(response?.devices);
        self.setCenter(response?.center);
        self.setLoading(false);
        self.setIsLoading(false, null);
      } catch (error) {
        console.log(error);
      }
    },
    sendAction: async (payload: any) => {
      try {
        const energymonitorApi = api.energymonitor;
        await energymonitorApi.changeStatus(payload);
        self.setIsLoading(true, payload.serial);
      } catch (error) {
        console.log(error);
      }
    },
  }));

type EnergyMonitorModelType = Instance<typeof EnergyMonitorModelAlarm>;
export type EnergyMonitor = EnergyMonitorModelType;
type EnergyMonitorSnapshotType = SnapshotOut<typeof EnergyMonitorModelAlarm>;
export type EnergyMonitorSnapshot = EnergyMonitorSnapshotType;
export const energymonitorDefaultModel = () =>
  types.optional(EnergyMonitorModelAlarm, {
    alarms: [],
    locationSelected: null,
    idSelected: null,
    isLoading: false,
    idLoading: null,
    center: { lat: 0, lng: 0 },
  });